const SDK_VERSION = '7.22.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
